import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Footer from '../Footer/Footer';
import LocalizationSelect from '../common/LocalizationSelect';
import { getLink } from '../common/FormatMessageComponents';
import Logo from '../../../assets/logo-long.png';
import BackArrow from '../../../assets/icons/back-arrow.svg';
import styles from './EnterLayout.scss';

interface EnterLayoutProps {
  children: ReactNode;
  showTermsAndPolicy?: boolean;
  showBackToProfile?: boolean;
  verticalPaddings?: number | { top: number; bottom: number };
}

/**
 * Layout for the sign up, log in, enter routes. Creates a container, top logo, wrapper for the form and a footer.
 */
const EnterLayout = ({ children, showTermsAndPolicy, showBackToProfile, verticalPaddings = 45 }: EnterLayoutProps) => {
  let paddingTop;
  let paddingBottom;

  if (typeof verticalPaddings === 'number') {
    paddingTop = verticalPaddings;
    paddingBottom = verticalPaddings;
  } else {
    paddingTop = verticalPaddings.top;
    paddingBottom = verticalPaddings.bottom;
  }

  return (
    <div className={styles.container}>
      <main>
        <div className={styles.logoLine}>
          <a href="https://clearvpn.com">
            <img src={Logo} alt="ClearVPN" width={142} height={24} />
          </a>

          <LocalizationSelect />
        </div>

        <div className={styles.innerContainer}>
          <section className={styles.formWrapper} style={{ paddingTop, paddingBottom }}>
            {showBackToProfile ? (
              <a href="/profile" className={styles.backToProfile}>
                <img src={BackArrow} alt="" />
                <FormattedMessage
                  id="layout.backToProfile"
                  defaultMessage="Back to profile"
                  description="Link in the corner of the screen, leading to the main account page"
                />
              </a>
            ) : null}

            {children}
          </section>

          {showTermsAndPolicy ? (
            <p className={styles.privacy}>
              <FormattedMessage
                id="layout.termsPolicyLinks"
                defaultMessage="By signing in, you agree to the <terms>Terms</terms> and <policy>Privacy Policy</policy>"
                description="Link in the corner of the screen, leading to the main account page"
                values={{
                  terms: getLink('https://clearvpn.com/terms-of-service', true),
                  policy: getLink('https://clearvpn.com/privacy-policy', true),
                }}
              />
            </p>
          ) : null}
        </div>

        <Footer className={styles.footer} />
      </main>
    </div>
  );
};

export default EnterLayout;
